import { httpInterceptor } from '../http-interceptor';

/**
 * Directory (Microsoft Entra ID / Azure AD) users, used to populate "who was present" /
 * "assigned to" style pickers across the app.
 */
export class UserService {
  static ENDPOINTS = {
    /** Plain JSON array ([{ Id, DisplayName, Email, JobTitle }]), not the ResponseDataModel envelope. */
    ENTRA_USERS: 'User/entra-users',
  };

  static mapEntraUser(row) {
    const r = row || {};
    const id = r.id ?? r.Id;
    const displayName = String(r.displayName ?? r.DisplayName ?? '').trim();
    const email = String(r.email ?? r.Email ?? '').trim();
    const jobTitle = String(r.jobTitle ?? r.JobTitle ?? '').trim();
    return {
      id: id != null && id !== '' ? String(id) : '',
      displayName: displayName || email || String(id ?? ''),
      email,
      jobTitle,
    };
  }

  /** GET User/entra-users — the full Entra ID directory, for client-side type-to-search pickers. */
  static async getEntraUsers() {
    const raw = await httpInterceptor.get(this.ENDPOINTS.ENTRA_USERS);
    const list = Array.isArray(raw) ? raw : [];
    return list
      .map(this.mapEntraUser)
      .filter(u => u.id && u.displayName)
      .sort((a, b) => a.displayName.localeCompare(b.displayName, undefined, { sensitivity: 'base' }));
  }
}
